import type { HTMLAttributes, ReactNode } from 'react';
import styles from './ProgressBar.module.css';
import { cx } from '../../lib/cx';

export interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  value: number;
  max?: number;
  thickness?: 'thin' | 'md' | 'thick';
  tone?: 'yellow' | 'success';
  label?: ReactNode;
  showValue?: boolean;
}

export function ProgressBar({
  value,
  max = 100,
  thickness = 'md',
  tone = 'yellow',
  label,
  showValue,
  className,
  ...rest
}: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className={cx(styles.wrap, className)} {...rest}>
      {(label || showValue) && (
        <div className={styles.label}>
          {label ? <span>{label}</span> : <span />}
          {showValue && <span>{Math.round(pct)} %</span>}
        </div>
      )}
      <div
        className={cx(styles.track, thickness === 'thin' && styles.thin, thickness === 'thick' && styles.thick)}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <div className={cx(styles.fill, tone === 'success' && styles['fill-success'])} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
